<div class="flex menu-item w100" *ngIf="userVerifiedBin">
    <a class="w100 d-flex flex-row align-center">
      <div class="mb-auto d-flex card-container justify-center">
        <img class="card-ic" src = "https://images.poshvine.com/icon/mas-card-icon.svg">
       
      </div>
      <div class="d-flex flex-column pad-left-10">
        <div class="drop-num fnt-16 card-number">
          {{userVerifiedBin | slice:0:4 }} {{userVerifiedBin | slice:-4 }} XXXX XXXX
        </div>
        <div i18n class="switch_card fnt-12 pointer" (click)="openLogin()">
          Switch Card
        </div>
      </div>
    </a>
</div>